var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 1772","d":"M29.536 25.293a1.634 1.634 0 000 2.243 1.474 1.474 0 002.146 0L43.548 15.13l.088-.1.043-.057.012-.013.015-.022.015-.022.012-.022.009-.006.012-.025.009-.01.009-.016.015-.025A1.613 1.613 0 0044 14a1.593 1.593 0 00-.209-.8l-.015-.029-.009-.013-.009-.013-.012-.022-.009-.009-.012-.019-.015-.025-.015-.022-.012-.013-.043-.057-.088-.1L31.686.478a1.474 1.474 0 00-2.146 0 1.63 1.63 0 000 2.24l9.29 9.711H1.515a1.586 1.586 0 000 3.168h37.311l-9.29 9.711z","fill":"#232a52"}));
}

Arrow.defaultProps = {"width":"44","height":"28","viewBox":"0 0 44 28"};

module.exports = Arrow;

Arrow.default = Arrow;
